"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ajaxFilter = void 0;
const support_1 = require("./support");
const masonryGrid_1 = require("./masonryGrid");
const ajaxFilter = (url = null) => {
    /**
     * Ajax filters
     */
    const ajaxFilters = document.querySelectorAll('[data-ajax="filter"]');
    const ajaxScreens = document.querySelectorAll('[data-ajax="screen"]');
    const ajaxContent = document.querySelectorAll('[data-update]');
    (0, masonryGrid_1.masonryGrid)();
    const ajaxFetch = (url, update = "replace") => {
        const xmlhttp = new XMLHttpRequest();
        ajaxContent.forEach(function (element) {
            if (update !== 'modal') {
                element.classList.add('is-loading');
            }
        });
        xmlhttp.onreadystatechange = function () {
            if (xmlhttp.readyState === XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
                if (xmlhttp.status === 200) {
                    const parser = new DOMParser();
                    const htmlDocument = parser.parseFromString(xmlhttp.response, "text/html");
                    const timeout = update !== 'modal' ? 500 : 0;
                    setTimeout(function () {
                        ajaxContent.forEach(function (element) {
                            let name = element.getAttribute('data-update');
                            let button = document.querySelector('.post-list__load');
                            let dataUpdate = htmlDocument.documentElement.querySelector('[data-update="' + name + '"]');
                            if (update === 'replace' || update === 'modal') {
                                element.innerHTML = dataUpdate ? dataUpdate.innerHTML : '';
                            }
                            if (update === 'append') {
                                element.innerHTML += dataUpdate ? dataUpdate.innerHTML : '';
                            }
                            if (button) {
                                button.innerHTML = htmlDocument.documentElement.querySelector('.post-list__load').innerHTML;
                            }
                            if (update !== 'modal') {
                                element.classList.remove('is-loading');
                            }
                            else {
                                let close = document.querySelector('[data-modal="close"]');
                                if (close) {
                                    close.focus();
                                }
                            }
                            if (name === 'diagnostic' || name === 'incidents') {
                                window.history.pushState('', '', url);
                            }
                        });
                        (0, masonryGrid_1.masonryGrid)();
                    }, timeout);
                }
                else if (xmlhttp.status === 400) {
                    console.warn('There was an error 400');
                }
                else {
                    console.warn(xmlhttp.status);
                }
            }
        };
        xmlhttp.open('GET', url, true);
        xmlhttp.send();
    };
    if (url) {
        // url passed directly to function (e.g. if a Google map marker has been clicked)
        ajaxFetch(url, 'modal');
    }
    document.addEventListener('click', function (e) {
        const target = e.target;
        if (target.matches('.post-list__load a')) {
            e.preventDefault();
            ajaxFetch(target.getAttribute('href'), 'append');
        }
        if (target.matches('[data-ajax="link"]')) {
            e.preventDefault();
            ajaxFetch(target.getAttribute('href'), 'replace');
        }
        if (target.matches('[data-ajax="modal"]')) {
            e.preventDefault();
            ajaxFetch(target.getAttribute('href'), 'modal');
        }
    });
    ajaxFilters.forEach(function (filter) {
        let buttonRefresh = filter.querySelector('[data-ajax="hidden"]');
        if (buttonRefresh) {
            buttonRefresh.parentNode.removeChild(buttonRefresh);
        }
        filter.addEventListener('change', function (e) {
            triggerFilter(filter);
        });
    });
    const triggerFilter = (filter) => {
        let params = (0, support_1.serialize)(filter);
        if (params) {
            params = filter.getAttribute('action').indexOf('?') > -1 ? '&' + params : '?' + params;
        }
        else {
            params = '?all';
        }
        ajaxFetch(filter.getAttribute('action') + params, 'replace');
    };
};
exports.ajaxFilter = ajaxFilter;
